import { useState } from "react";
import { useAdvisorAcceptConnectionMutation } from "web_myplann/Api/Advisor/useAdvisorAcceptConnectionMutation";
import { useAdvisorRefuseConnectionMutation } from "web_myplann/Api/Advisor/useAdvisorRefuseConnectionMutation";
import { useApprovingAdvisorIds } from "web_myplann/Api/Advisor/useApprovingAdvisorIds";
import type { AgentAssignedListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const useAdvisorPendingActions = () => {
	const [refusedAdvisor, setRefusedAdvisor] =
		useState<AgentAssignedListItemResponseDTO>();
	const { mutate: approveConnection } = useAdvisorAcceptConnectionMutation();
	const { mutate: refuseConnection, isPending: isRefusing } =
		useAdvisorRefuseConnectionMutation();
	const approvingIds = useApprovingAdvisorIds();

	const dismissRefuse = () => setRefusedAdvisor(undefined);

	return {
		refusedAdvisor,
		approvingIds,
		isRefusing,
		approve: (advisorId: number) => approveConnection(advisorId),
		requestRefuse: (advisor: AgentAssignedListItemResponseDTO) =>
			setRefusedAdvisor(advisor),
		dismissRefuse,
		confirmRefuse: () => {
			if (!refusedAdvisor) return;
			refuseConnection(refusedAdvisor.id, { onSuccess: dismissRefuse });
		},
	};
};
